import React, { useState, useEffect, useReducer } from "react";
import { GoAContainer, GoABadge, GoATable, GoAButton, GoAButtonGroup, GoAButtonType, GoACheckbox, GoADropdown, GoADropdownItem, GoABlock, GoAIcon, GoAFormItem, GoASpacer, GoADivider, GoAPopover } from "@abgov/react-components";

interface MediaUploadCardProps {
  collisionId: string;
  filename: string;
  size: number;
  type?: string;
  lastModified?: Date;
  progress?: number;
  error?: string;
  onCancel?: () => void;
  onRemove: () => void;
}

interface SelectedOption {
  name: string;
  value: string;
  content: string;
}

const MediaUploadCard: React.FC<MediaUploadCardProps> = ({ collisionId, filename, size, type, lastModified, progress, error, onCancel, onRemove }) => {
  const [isFirstPointOfImpact, setIsFirstPointOfImpact] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<SelectedOption[]>([]);   //TODO: Add to state
  const [checkboxOptions] = useState([
    { name: '1', text: 'Option 1', value: '1' },
    { name: '2', text: 'Intersection', value: '2' },
    { name: '3', text: 'Other', value: '3' },
  ]);                                                             //TODO: Retrieve from API
  const [badges, setBadges] = useState<JSX.Element[]>([]);

  //TODO: Remove below test data
  //const imageUrl = "/images/placeholder.png"
  const imageUrl = `http://localhost:8000/api/v1/collisions/${collisionId}/media/image?file_name=${filename}`;
  const lastModifiedDate = lastModified || new Date();

  const handleCheckboxChange = (name: string, checked: boolean, value: string) => {
    setIsFirstPointOfImpact(checked);
  };

  const getFormattedDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  };

  const formatSize = (size: number) => {
    if (size < 1024) {
      return `${size} bytes`;
    } else if (size < 1024 * 1024) {
      return `${(size / 1024).toFixed(1)} KB`;
    } else {
      return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    }
  };

  function onChange(name: string, value: string | string[]) {
    console.log("onChange", name, value);
  }

  const getTextForValue = (value: string) => {
    const option = checkboxOptions.find(option => option.value === value);
    return option ? option.text : value;
  };

  //TODO: Check why the value is not passed when the checkbox is unchecked
  const handleLabelSelected = (name: string, checked: boolean, value: string | number | boolean) => {
    if (checked) {
      const content = getTextForValue(value.toString());
      setSelectedOptions((prevSelectedOptions) => [...prevSelectedOptions, { name, value: value.toString(), content: value.toString() }]);
      setBadges((prevBadges) => [...prevBadges, <GoABadge key={name} type="dark" content={content} />]);
    } else {
      setSelectedOptions((prevSelectedOptions) => prevSelectedOptions.filter((option) => option.name !== name));
      setBadges((prevBadges) => prevBadges.filter((badge) => badge.key !== name));
    }
  };

  useEffect(() => {
    console.log('Selected options:', selectedOptions);
    console.log('file name :', filename, collisionId);
  }, [selectedOptions]);


  const fillCheckboxes = (options: { name: string; text: string; value: string }[]) => {
    return options.map((option) => (
      <GoACheckbox
        key={option.name}
        name={option.name}
        text={option.text}
        value={option.value}
        onChange={(name, checked, value) => handleLabelSelected(name, checked, value ? value.toString() : '')}
        checked={selectedOptions.some((opt) => opt.value === option.value)}
      />
    ));
  };

  return (
    <GoAContainer accent="filled" width="full">
      <div style={{ padding: '16px' }}>
        <div style={{ position: 'relative', marginBottom: '10px' }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            alignItems: 'center',
            marginBottom: '10px'
          }}>
            {badges}
          </div>
          <div style={{ height: '60%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#eaeaea' }}>
            <img src={imageUrl} alt="file preview" style={{ width: '100%', height: 'auto' }} />
          </div>
          <GoASpacer vSpacing="2xs" />
          <GoABlock gap="xs" direction="row" alignment="start">
            <div>
              <a href={imageUrl || '#'} target="_blank" rel="noopener noreferrer">{filename}</a>
            </div>
            <div>
              <GoAIcon type="eye" />
            </div>
            <div>
              {formatSize(size)}
            </div>
          </GoABlock>
          <div style={{ color: '#666', fontSize: '12px' }}>{getFormattedDate(new Date(lastModifiedDate))}</div>
        </div>
        <GoAButtonGroup alignment="start">
          <div style={{ display: 'flex', gap: '8px' }}>
            <GoAButton type="tertiary" size="compact" onClick={onRemove}>Remove</GoAButton>
            <GoAPopover target={(<GoAButton type="tertiary" trailingIcon="chevron-down" size="compact">Add label</GoAButton>)} position="below">
              <GoAFormItem label="">
                {fillCheckboxes(checkboxOptions)}
              </GoAFormItem>
            </GoAPopover>
          </div>
        </GoAButtonGroup>
        <GoADivider mt="xs" mb="xs"></GoADivider>
        <GoAFormItem>
          <GoACheckbox name="firstPointOfImpact" text="Is this the first point of impact" onChange={handleCheckboxChange} checked={false} />
        </GoAFormItem>
      </div>
    </GoAContainer>
  );

};

export default MediaUploadCard;
